import '../../blocks/accordion/accordion.js';
import '../../blocks/content_carousel/content_carousel.js';
import '../../blocks/content_slider/content_slider.js';
import '../../blocks/media_carousel/media_carousel.js';
import '../../blocks/meet_the_team/meet_the_team.js';
import '../../blocks/stat_counters/stat_counters.js';
import '../../blocks/testimonials/testimonials.js';
import '../../blocks/text_with_media_grouped/text_with_media_grouped.js';
import '../../blocks/trustmarks/trustmarks.js';
import '../../blocks/spotlight_slider/spotlight_slider.js';
import './posts-hub.js';

// Add your custom JS here.

const mobileNavToggle = document.querySelector('.mobile-nav-toggle');
const adaptiveHeader = document.querySelector('.adaptive-header');
const siteHeaderBar = document.querySelector('#site-header');

// Inject a toggle button beside each parent menu item's link
document.querySelectorAll('.main-menu > .menu-item-has-children').forEach(li => {
    const btn = document.createElement('button');
    btn.className = 'submenu-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Toggle submenu');
    li.querySelector(':scope > a').before(btn);

    const subMenu = li.querySelector(':scope > .sub-menu');

    btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (!isOpen) {
            const subHeight = subMenu.scrollHeight;
            subMenu.style.height = subHeight + 'px';
            adaptiveHeader.style.height = (parseFloat(adaptiveHeader.style.height) + subHeight) + 'px';
            btn.setAttribute('aria-expanded', 'true');
        } else {
            const subHeight = parseFloat(subMenu.style.height);
            subMenu.style.height = '0';
            adaptiveHeader.style.height = (parseFloat(adaptiveHeader.style.height) - subHeight) + 'px';
            btn.setAttribute('aria-expanded', 'false');
        }
    });
});

mobileNavToggle.addEventListener('click', function() {
    const isOpen = mobileNavToggle.classList.contains('clicked');

    if (!isOpen) {
        // Header colour changes immediately, then menu slides down
        mobileNavToggle.classList.add('clicked');
        siteHeaderBar.classList.add('mobile-menu-active');
        adaptiveHeader.style.height = adaptiveHeader.scrollHeight + 'px';
    } else {
        // Menu slides up first, header colour reverts only once it finishes
        document.querySelectorAll('.submenu-toggle[aria-expanded="true"]').forEach(btn => {
            btn.closest('li').querySelector('.sub-menu').style.height = '0';
            btn.setAttribute('aria-expanded', 'false');
        });
        mobileNavToggle.classList.remove('clicked');
        adaptiveHeader.style.height = '0';
        adaptiveHeader.addEventListener('transitionend', function() {
            siteHeaderBar.classList.remove('mobile-menu-active');
        }, { once: true });
    }
});

// Reset inline heights and state when resizing back to desktop
window.addEventListener('resize', () => {
    if (window.innerWidth >= 992) { // Bootstrap default lg breakpoint — matches $grid-breakpoints lg in SCSS
        adaptiveHeader.style.height = '';
        document.querySelectorAll('.sub-menu').forEach(s => s.style.height = '');
        document.querySelectorAll('.submenu-toggle').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
        mobileNavToggle.classList.remove('clicked');
        siteHeaderBar.classList.remove('mobile-menu-active');
    }
});


/**
 * Custom JS control for the vertical and horizontal
 * tabbed content layouts
 */
document.addEventListener('DOMContentLoaded', function() {
    let tabContainers = document.querySelectorAll('.tabs');
    if(!tabContainers) return;

    tabContainers.forEach((tabContainer) => {
        let tabSelectors = tabContainer.querySelectorAll('.selector');
        let tabPanels = tabContainer.querySelectorAll('.tab-panel');

        tabSelectors.forEach((selector) => {
            selector.addEventListener('click', function() {
                let targetID = selector.getAttribute('id');

                tabSelectors.forEach((tsel) => {
                    tsel.classList.remove('active');
                })
                tabPanels.forEach((panel) => {
                    panel.classList.remove('active');
                });

                selector.classList.toggle('active');
                const activePanel = tabContainer.querySelector(`.tab-panel[data-target="${targetID}"]`);
                activePanel.classList.toggle('active');

                if (window.innerWidth < 992) {
                    const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
                    const panelTop = activePanel.getBoundingClientRect().top + window.scrollY - (remInPx * 2);
                    window.scrollTo({ top: panelTop, behavior: 'smooth' });
                }
            });
        });
    });

    let dropDownHeaders = document.querySelectorAll('.dropdown-header');
    if(!dropDownHeaders) return;

    dropDownHeaders.forEach((dropDownHeader) => {
        let listToShow = dropDownHeader.nextElementSibling;

        dropDownHeader.addEventListener('click', function() {
            const isActive = dropDownHeader.classList.contains('active');

            if (isActive) {
                setTimeout(() => dropDownHeader.classList.remove('active'), 350);
                listToShow.classList.remove('active');
                listToShow.style.maxHeight = '0px';
            } else {
                dropDownHeader.classList.add('active');
                listToShow.classList.add('active');
                listToShow.style.maxHeight = listToShow.scrollHeight + 'px';
            }
        });
    });

    // When resizing past the mobile breakpoint, clear inline maxHeight so
    // desktop CSS is no longer overridden by the mobile JS-set values.
    window.addEventListener('resize', function() {
        if (window.innerWidth >= 768) {
            dropDownHeaders.forEach((dropDownHeader) => {
                let listToShow = dropDownHeader.nextElementSibling;
                dropDownHeader.classList.remove('active');
                listToShow.classList.remove('active');
                listToShow.style.maxHeight = '';
            });
        }
    });

    /**
     * Ensure vertical tabs sections are tall enough for their
     * absolutely-positioned text wrappers.
     */
    function updateVerticalTabsHeight() {
        let verticalSections = document.querySelectorAll('.tabbed-content .vertical-tabs');

        verticalSections.forEach((section) => {
            let block = section.closest('.page-block .container-fluid');
            if(!block) return;

            let textWrappers = section.querySelectorAll('.tab-panel .text-wrapper');
            let tallest = 0;

            textWrappers.forEach((wrapper) => {
                tallest = Math.max(tallest, wrapper.offsetHeight);
            });

            if(tallest > 0) {
                let margin = 80;
                let minHeight = tallest + margin;
                block.style.minHeight = minHeight + 'px';
            }
        });
    }

    updateVerticalTabsHeight();
    window.addEventListener('resize', updateVerticalTabsHeight);
});